<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
};
</script>

<style lang="scss">
html,
body {
  position:absolute;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}

</style>
